import { ArrowLeft } from "@phosphor-icons/react";

export default function PrivacyPolicy({ onBack }) {
  return (
    <div className="w-full min-h-screen bg-white dark:bg-zinc-950 transition-colors" data-testid="privacy-policy-page">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 py-12">
        <button
          onClick={onBack}
          className="flex items-center gap-1.5 text-[11px] font-mono uppercase tracking-wider text-zinc-400 dark:text-zinc-500 hover:text-zinc-700 dark:hover:text-zinc-300 transition-colors mb-8"
          data-testid="back-to-app-btn"
        >
          <ArrowLeft size={14} weight="bold" />
          Back to Screener
        </button>

        <h1 className="text-3xl font-light text-zinc-950 dark:text-zinc-100 mb-2">Privacy Policy</h1>
        <p className="text-xs font-mono text-zinc-400 dark:text-zinc-500 mb-8">Last updated: March 2026</p>

        <div className="space-y-6 text-sm text-zinc-600 dark:text-zinc-400 leading-relaxed">
          <section>
            <h2 className="text-base font-medium text-zinc-950 dark:text-zinc-100 mb-2">Data Collection</h2>
            <p>
              This application collects anonymous usage data through Google Analytics 4 and Microsoft Clarity.
              This data helps us understand how the tool is used and improve the experience. No personal
              information, login credentials, or financial data is collected or stored about individual users.
            </p>
          </section>

          <section>
            <h2 className="text-base font-medium text-zinc-950 dark:text-zinc-100 mb-2">What We Track</h2>
            <ul className="list-disc ml-5 space-y-1">
              <li>Page views and navigation patterns</li>
              <li>Stock searches and filter usage (anonymous, aggregated)</li>
              <li>Feature usage metrics (CSV exports, portfolio screens)</li>
              <li>Session recordings and heatmaps (via Microsoft Clarity, anonymized)</li>
              <li>Traffic source (UTM parameters — e.g., LinkedIn, direct)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-base font-medium text-zinc-950 dark:text-zinc-100 mb-2">What We Do Not Collect</h2>
            <ul className="list-disc ml-5 space-y-1">
              <li>Names, email addresses, or any personally identifiable information</li>
              <li>Financial portfolio data or investment decisions</li>
              <li>Login credentials (no login is required)</li>
              <li>IP addresses are anonymized by Google Analytics</li>
            </ul>
          </section>

          <section>
            <h2 className="text-base font-medium text-zinc-950 dark:text-zinc-100 mb-2">Third-Party Services</h2>
            <p>
              We use the following third-party services to provide functionality:
            </p>
            <ul className="list-disc ml-5 space-y-1 mt-2">
              <li><strong>Google Analytics 4</strong> — anonymous usage analytics</li>
              <li><strong>Microsoft Clarity</strong> — session recordings and heatmaps (anonymized)</li>
              <li><strong>Financial Modeling Prep</strong> — real-time financial data</li>
              <li><strong>Yahoo Finance</strong> — stock charts and news</li>
            </ul>
          </section>

          <section>
            <h2 className="text-base font-medium text-zinc-950 dark:text-zinc-100 mb-2">Authentication</h2>
            <p>
              Users may optionally sign in via Google OAuth to access premium features. When you sign in,
              we store only your email address and display name for authentication purposes. Your email is
              never sold, shared with third parties, or used for marketing. No personal data is sold.
              Only anonymous analytics are collected via Google Analytics 4 and Microsoft Clarity.
              User email is only used for authentication and linking your watchlist and preferences.
            </p>
          </section>

          <section>
            <h2 className="text-base font-medium text-zinc-950 dark:text-zinc-100 mb-2">Cookies</h2>
            <p>
              Google Analytics and Microsoft Clarity may use cookies to track anonymous session data.
              These are strictly for analytics purposes and do not contain personal information.
            </p>
          </section>

          <section>
            <h2 className="text-base font-medium text-zinc-950 dark:text-zinc-100 mb-2">Disclaimer</h2>
            <p>
              This tool provides informational screening based on financial data and commonly used Shariah
              compliance criteria. It does not constitute financial or religious advice. Users should consult
              qualified professionals for final decisions.
            </p>
          </section>

          <section>
            <h2 className="text-base font-medium text-zinc-950 dark:text-zinc-100 mb-2">Contact</h2>
            <p>
              For questions about this privacy policy, please reach out through the application's contact channels.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
